//@vendor
const get = require('lodash/object/get');

//@constants
const actionTypes = require('constants/contactCenter/actionTypes');
const { ERROR_INVALID_INTERACTION_ID_CODE } = require('constants/contactCenter/errorTypes');

//@utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const authenticationHelper = require('utilities/contactCenter/authenticationHelper');
const { isInOffice, retrieveAgentToken } = require('utilities/contactCenter/disasterRecoveryhelper');
const { formatText } = require('core/i18n').i18n;

const setInteractionIdErrorMessage = errorMessage => ({
    type: actionTypes.CUSTOMER_FINDER_SET_INTERACTION_ID_ERROR_MESSAGE,
    payload: {
        errorMessage
    }
});

const updateInteractionId = value => ({
    type: actionTypes.CUSTOMER_FINDER_SAVE_INTERACTION_ID,
    payload: {
        value
    }
});

const clearInteractionIdErrorMessage = () => dispatch => {
    dispatch(setInteractionIdErrorMessage(''));
}

const validateInteractionIdWithAPIStart = () => ({
    type: actionTypes.CUSTOMER_FINDER_VALIDATE_WITH_API_START
});

const validateInteractionIdWithAPISuccess = () => ({
    type: actionTypes.CUSTOMER_FINDER_VALIDATE_WITH_API_SUCCESS
});

const validateInteractionIdWithAPI = interactionId => (dispatch) => {
    const inOffice = isInOffice();
    const agentToken = retrieveAgentToken();

    const errorMessage = authenticationHelper.validateInteractionId(interactionId);
    dispatch(setInteractionIdErrorMessage(errorMessage));

    if (!!errorMessage) {
        // If there is an error with interaction ID format, don't call the service
        return;
    }

    if (inOffice) {
        // When is in office the interaction ID is provided by a different system and we cannot validate it yet
        dispatch(validateInteractionIdWithAPISuccess());
        return;
    }

    dispatch(validateInteractionIdWithAPIStart());

    let requestData = {
        header: {
            openBankToken: agentToken
        },
        query: {
            openBankInteractionId: interactionId
        }
    };

    return APIGet({
        dispatch,
        endpoint: 'interactionIdValidation',
        url: apiURLBuilder.getURL('interactionIdValidation'),
        params: requestData
    })
    .then(() => {
        dispatch(validateInteractionIdWithAPISuccess());
    })
    .catch(response => {
        if (get(response, 'error.description.code') === ERROR_INVALID_INTERACTION_ID_CODE) {
            dispatch(setInteractionIdErrorMessage(formatText('stepValidateInteractionId-errorInvalidInteractionId')));
        } else {
            dispatch(setInteractionIdErrorMessage(formatText('stepValidateInteractionId-errorServiceUnavailable')));
        }
    });
};

const validateInteractionId = interactionId => (dispatch) => {
    const errorMessage = authenticationHelper.validateInteractionId(interactionId);
    dispatch(setInteractionIdErrorMessage(errorMessage));
};

module.exports = {
    clearInteractionIdErrorMessage,
    validateInteractionId,
    validateInteractionIdWithAPI,
    updateInteractionId,
};
